import React, { useState, useEffect } from "react";
import { Card, Col, Row, Typography, Table, Tag, Skeleton, Radio, Avatar } from "antd";
import { Link } from 'react-router-dom';
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import moment from 'moment';
import { formatDate, formatDateTime } from "../../helper/DateHelper";
import { Bar } from "react-chartjs-2";
import apiPath from "../../constants/apiPath";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement } from "chart.js";

function Home() {

  const { Title }                         =   Typography;
  const { request }                       =   useRequest();
  const [loading, setLoading]             =   useState(false);
  const [userGraphData, setGraphUserData] =   useState({});
  const [barData, setBarData]             =   useState(false);
  const [recentUser, setRecentUser]       =   useState([]);
  const [recentBrand, setRecentBrand]     =   useState([]);
  const [dashboard, setDashboard]         =   useState({});

  ChartJS.register(CategoryScale, LinearScale, BarElement);

  const options = {
    responsive: true,
    indexAxis: 'x',
  }

  const userColumns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 200,
      sorter: (a, b) => a.name.localeCompare(b.name),
      render: (_, { name }) => {
        return (
          <>
            <Avatar className="cap" size={40}> {name?.charAt(0)} </Avatar>
            <a style={{ marginLeft: 12 }} className="cap avatar-text">{name}</a>
          </>
        );
      },
    },
    {
      title: "Mobile Number",
      sorter: (a, b) => a.mobile_number.localeCompare(b.mobile_number),
      render: (_, { mobile_number, country_code }) => {
        return (
          (country_code ? "+" + country_code + "-" : "+91") + (mobile_number ? mobile_number : '')
        );
      },
    },
    {
      title: "Email Address",
      dataIndex: "email",
      key: "email",
      width: 250,
      sorter: (a, b) => a.email.localeCompare(b.email),
      render: (_, { email }) => {
        return email ? email : '-';
      },
    },
    {
      title: "DOB",
      dataIndex: "dob",
      key: "dob",
      sorter: (a, b) => a.dob.localeCompare(b.dob),
      render: (_, { dob }) => {
        return dob ? dob : '-';
      },
    },
    {
      title: "Status",
      key: "is_active",
      render: (_, { is_active }) => {
        let color = is_active ? 'green' : 'red';
        return (<Tag color={color} key={is_active}>{is_active ? "Active" : "Inactive"}</Tag>);
      },
    },
    {
      title: "OTP Verification Status",
      key: "is_otp_verify",
      render: (_, { is_otp_verify }) => {
        let color = is_otp_verify ? 'green' : 'red';
        return <Tag color={color} key={is_otp_verify}>{is_otp_verify ? "Verified" : "Not Verified"}</Tag>;
      },
    },
    {
      title: "Registered On",
      key: "created_at",
      dataIndex: "created_at",
      sorter: (a, b) => a.created_at.localeCompare(b.created_at),
      render: (_, { created_at }) => {
        return (
          formatDate(created_at)
        );
      },
    },
  ];

  const brandColumns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      render: (_, { name }) => {
        return <span className="cap">{name}</span>
      },
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      sorter: (a, b) => a.category_id.localeCompare(b.category_id),
      render: (_, { category_id }) => {
        return (
          category_id && category_id.name ? <span className="cap">{category_id.name}</span> : '-'
        );
      },
    },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
      render: (_, { city_id, city_selection }) => {
        if (city_selection === 'Single City') {
          return city_id && city_id.name ? <span className="cap">{city_id.name}</span> : '-';
        } else if (city_selection) {
          return city_selection;
        } else {
          return '-';
        }
      },
    },
    {
      title: "Cluster",
      dataIndex: "cluster",
      key: "cluster",
      sorter: (a, b) => a.cluster_id.localeCompare(b.cluster_id),
      render: (_, { cluster_id }) => {
        return (
          cluster_id && cluster_id.name ? <span className="cap">{cluster_id.name}</span> : '-'
        );
      },
    },
    {
      title: "Status",
      key: "is_active",
      render: (_, { is_active }) => {
        let color = is_active ? 'green' : 'red';
        return <Tag color={color} key={is_active}>{is_active ? "Active" : "Inactive"}</Tag>;
      },
    },
    {
      title: "Registered On",
      key: "created_at",
      dataIndex: "created_at",
      sorter: (a, b) => a.created_at.localeCompare(b.created_at),
      render: (_, { created_at }) => {
        return (
          formatDate(created_at)
        );
      },
    },
  ];

  const userMonthlyCount = (data) => {
    const Cmonths = data?.userGraph?.userMonthlyCount?.map(item => item?.month);
    const Ccounts = data?.userGraph?.userMonthlyCount?.map(item => item?.count);
    const userChartData = {
      labels: Cmonths,
      datasets: [
        {
          label: "User Monthly",
          data: Ccounts,
          backgroundColor: 'rgb(70, 22, 122, 0.1)',
          borderColor: 'rgb(70, 22, 122)',
          borderWidth: 1,
        },
      ],
    };
    setGraphUserData(userChartData)
  }

  const userWeeklyCount = () => {
    const Cmonths = dashboard?.userGraph?.userWeeklyCount?.map(item => item?.week);
    const Ccounts = dashboard?.userGraph?.userWeeklyCount?.map(item => item?.count);
    const userChartData = {
      labels: Cmonths,
      datasets: [
        {
          label: "User Weekly",
          data: Ccounts,
          backgroundColor: 'rgb(70, 22, 122, 0.1)',
          borderColor: 'rgb(70, 22, 122)',
          borderWidth: 1,
        },
      ],
    };
    setGraphUserData(userChartData)
  }

  const userYearlyCount = () => {
    const Cmonths = dashboard?.userGraph?.userYearlyCount?.map(item => item?.year);
    const Ccounts = dashboard?.userGraph?.userYearlyCount?.map(item => item?.count);
    const userChartData = {
      labels: Cmonths,
      datasets: [
        {
          label: "User Yearly",
          data: Ccounts,
          backgroundColor: 'rgb(70, 22, 122, 0.1)',
          borderColor: 'rgb(70, 22, 122)',
          borderWidth: 1,
        },
      ],
    };
    setGraphUserData(userChartData)
  }

  const count = [
    {
      today: "No. of Active / Reg. User",
      title: `${dashboard && dashboard.activeUserCount || 0} / ${dashboard && dashboard.userCount || 0}`,
      persent: "10%",
      icon: <i class="fas fa-users"></i>,
      bnb: "bnb2",
      url: '/user'
    },
    {
      today: "No. of Active / Reg. Category",
      title: `${dashboard && dashboard.activeCategoryCount || 0} & ${dashboard && dashboard.categoryCount || 0}`,
      icon: <i class="fa-solid fa-list"></i>,
      bnb: "bnb2",
      url: '/finance'
    },
    {
      today: "No. of Active / Reg. Brand",
      title: `${dashboard && dashboard.activeBrandCount || 0} & ${dashboard && dashboard.brandCount || 0}`,
      icon: <i class="fa-solid fa-shop"></i>,
      bnb: "bnb2",
      url: '/brand'
    },
    {
      today: "No. of Active / Reg. Cluster",
      title: `${dashboard && dashboard.activeClusterCount || 0} & ${dashboard && dashboard.clusterCount || 0}`,
      icon: <i class="fab fa-skyatlas"></i>,
      bnb: "bnb2",
      url: '/cluster'
    },
    {
      today: "No. of Active / Reg. Tag",
      title: `${dashboard && dashboard.activeTagCount || 0} & ${dashboard && dashboard.tagCount || 0}`,
      icon: <i class="fas fa-tag"></i>,
      bnb: "bnb2",
      url: '/tag'
    },
    {
      today: "No. of Active / Reg. City",
      title: `${dashboard && dashboard.activeCityCount || 0} & ${dashboard && dashboard.cityCount || 0}`,
      icon: <i class="fab fa-skyatlas"></i>,
      bnb: "bnb2",
      url: '/city'
    },
  ];

  useEffect(() => {
    setLoading(true)
    request({
      url: apiPath.dashboard, 
      method: 'POST',
      onSuccess: (data) => {
        setLoading(false)
        setDashboard(data.data);
        userMonthlyCount(data?.data);
        setBarData(true);
        setRecentUser(data.data.recentUser);
        setRecentBrand(data.data.recentBrand);
      },
      onError: (error) => {
        setLoading(false)
        ShowToast(error, Severty.ERROR)
      }
    })
  }, [])
 
  return (
    <>
      <div className="layout-content">
        
        <div className="mb-24">
          <Row gutter={[24, 0]}>
            <Col xs={24} sm={18} md={24}>
              <Row className="rowgap-vbox" gutter={[24, 16]}>

                {count.map((c, index) => (
                  <Col key={index} xs={24} sm={24} md={12} lg={12} xl={8} xxl={6}>
                    <Link to={c.url}>
                      <Card bordered={false} className="criclebox" style={{height:"100%"}}>
                        <div className="number">
                          <Row align="middle" gutter={[24, 0]}>
                            <Col xs={18}>
                                <span>{c.today}</span>
                                <Title level={3}>{c.title}</Title>
                            </Col>
                            <Col xs={6}> <div className="icon-box">{c.icon}</div></Col>
                          </Row>
                        </div>
                      </Card>
                    </Link>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </div>

        <Row gutter={[24, 16]}>
          <Col xs={24} xl={12} className="mb-24">
            <Card bordered={false} className="criclebox h-full">
              <Title level={5}>User Activity Insights</Title>
              
              <Row style={{ justifyContent: "end" }}>
                <Radio.Group defaultValue="month" buttonStyle="solid">
                  <Radio.Button className="chart-btn" onClick={userWeeklyCount} value="week">Week</Radio.Button>
                  <Radio.Button className="chart-btn" onClick={() => userMonthlyCount(dashboard)} value="month">Month</Radio.Button>
                  <Radio.Button className="chart-btn" onClick={userYearlyCount} value="year">Year</Radio.Button>
                </Radio.Group>
              </Row>
              
              {loading ? [1, 2, 3].map(item => <Skeleton active key={item} />) : <>{barData && <Bar data={userGraphData} options={options} />}</>}

            </Card>
          </Col>

          <Col xs={24} xl={12} className="mb-24">
            <Card bordered={false} className="criclebox h-full">
              <Title level={5}>Brand Insights</Title>
              
              <Row style={{ justifyContent: "end" }}>
                <Radio.Group defaultValue="month" buttonStyle="solid">
                  <Radio.Button className="chart-btn" onClick={userWeeklyCount} value="week">Week</Radio.Button>
                  <Radio.Button className="chart-btn" onClick={() => userMonthlyCount(dashboard)} value="month">Month</Radio.Button>
                  <Radio.Button className="chart-btn" onClick={userYearlyCount} value="year">Year</Radio.Button>
                </Radio.Group>
              </Row>
              
              {loading ? [1, 2, 3].map(item => <Skeleton active key={item} />) : <>{barData && <Bar data={userGraphData} options={options} />}</>}

            </Card>
          </Col>
        </Row>

        <Row gutter={[24, 16]}>
          <Col span={24}>
            <Card bordered={false} className="criclebox tablespace" style={{ marginBottom: '16px' }}>
              <p className="dashboard-table-heading">Recently Joined User (10)</p>
              <div className="table-responsive">
                <Table
                  loading={loading}
                  columns={userColumns}
                  dataSource={recentUser}
                  pagination={false}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>

          <Col span={24}>
            <Card bordered={false} className="criclebox tablespace" style={{ marginBottom: '16px' }}>
              <p className="dashboard-table-heading">Recent Registered Brands (10)</p>
              <div className="table-responsive">
                <Table
                  loading={loading}
                  columns={brandColumns}
                  dataSource={recentBrand}
                  pagination={false}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>

      </div>
    </>
  );
}

export default Home;
